import AuthSubtitle from 'src/features/auth/components/auth-subtitle'
import AuthTitle from 'src/features/auth/components/auth-title'
import GreenPawn from 'src/shared/assets/images/green-pawn.png'
import { Button } from 'src/shared/components/ui/buttons/button'

interface AuthSuccessConsumerProps {
  title: string
  description: string
  className?: string
  onClose?: () => void
}

export default function AuthSuccessConsumer({ title, description, className, onClose }: AuthSuccessConsumerProps) {
  return (
    <div className={className}>
      <div className="flex flex-col items-center justify-center">
        <div className="mx-auto h-[120px] w-[101px] translate-x-[-10px]">
          <img src={GreenPawn} alt="Auth Success Icon" className="size-full object-contain" />
        </div>
        <AuthTitle title={title} className="text-[32px]" />
        <AuthSubtitle description={description} className="text-[16px]" />
        <Button onClick={onClose} className="h-[55px] w-full max-w-[380px] rounded-full text-[15px] font-semibold">
          Close
        </Button>
      </div>
    </div>
  )
}
